module.exports = __webpack_public_path__ + "img/kw.7a17a936.svg";